"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopUpCTA = exports.PopUpText = exports.PopUpTitle = exports.PopUpContainer = exports.Title = exports.ButtonCloseModal = exports.customStyles = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
exports.customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#00000090',
    },
    content: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#DCE3E7',
        border: 'none',
        borderRadius: '0',
        padding: '1rem',
    },
};
exports.ButtonCloseModal = styled_components_1.default.button `
  align-self: flex-end;
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  height: 30px;
  width: 30px;

  &:before {
    content: 'X';
    color: #fff;
    font-weight: 200;
    font-size: 1rem;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    background-color: ${theme_1.colors.lightGrey};
  }
`;
exports.Title = styled_components_1.default.h2 `
  text-decoration: none;
  text-transform: capitalize;
  font-weight: 700;
  font-size: 1.5rem;
`;
exports.PopUpContainer = styled_components_1.default.div ``;
exports.PopUpTitle = styled_components_1.default.div `
  padding-top: 10%;
  padding-bottom: 10px;
  text-align: center;
  font-weight: 900;
  font-style: italic;
  font-size: 28px;
  font-family: PFDINText;
  text-transform: uppercase;
  color: ${theme_1.colors.blue};
`;
exports.PopUpText = styled_components_1.default.div `
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  font-family: PFDINText;
  color: ${theme_1.colors.white};
`;
exports.PopUpCTA = styled_components_1.default.div `
  padding: 10px 0;
  display: flex;
  justify-content: center;
`;
